import React, { useEffect } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";

import { Loading } from "commons";
import { getRangeStringFromId, ALL_DATES } from "commons/src/NuDateUtils";
import { isPrintMode } from "commons/src/QueryParameter";

import { FolioDetails } from "./FolioDetails";
import { fetchPPForClient } from "../../components/DataOperations";
import { requestObject } from "../../reducers/requestsActions";

function FolioDetailsContainerComponent({
    clientId,
    analysis,
    accounts,
    match,
    roles,
    modelPortfolioRequestStatus,
    accountDetailsRequestStatus,
    stateToPrint
}) {
    useEffect(() => {
        !isPrintMode() && fetchMissingData(clientId, analysis);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const fetchMissingData = (clientId, analysis) => {
        if (!analysis) {
            fetchPPForClient(clientId, ALL_DATES.id);
        }
    };

    return (
        <Loading
            className={"spinner-big"}
            displayWhen={
                !!accounts &&
                (!!accounts[match.params.accountNum] || match.params.accountNum === "Combined") &&
                !!analysis
            }
            size={35}
        >
            <FolioDetails
                isCombined={match.params.accountNum === "Combined"}
                clientId={clientId}
                params={match.params}
                accounts={accounts}
                analysis={analysis}
                roles={roles}
                modelPortfolioRequestStatus={modelPortfolioRequestStatus}
                accountDetailsRequestStatus={accountDetailsRequestStatus}
                stateToPrint={stateToPrint}
            />
        </Loading>
    );
}

FolioDetailsContainerComponent.propTypes = {
    match: PropTypes.shape({
        params: PropTypes.shape({
            accountNum: PropTypes.string
        })
    }),
    accounts: PropTypes.object,
    analysis: PropTypes.object,
    clientId: PropTypes.number,
    roles: PropTypes.arrayOf(PropTypes.string),
    modelPortfolioRequestStatus: requestObject,
    accountDetailsRequestStatus: requestObject,
    stateToPrint: PropTypes.shape({
        accounts: PropTypes.object,
        analysis: PropTypes.object,
        requests: PropTypes.object,
        theme: PropTypes.object,
        user: PropTypes.object
    })
};

const mapStateToProps = (state, props) => {
    const analysis = state.analysis || {};
    return {
        clientId: state.user.currentUser.clientId,
        accounts: state.accounts,
        analysis: analysis[getRangeStringFromId(ALL_DATES.id)],
        roles: state.user.roles,
        modelPortfolioRequestStatus:
            state.requests[`${props.match.params.accountNum}_modelPortfolio`],
        accountDetailsRequestStatus:
            state.requests[`${props.match.params.accountNum}_accountDetails`],
        stateToPrint: {
            accounts: state.accounts,
            adviser: state.adviser,
            analysis: state.analysis,
            requests: state.requests,
            theme: state.theme,
            user: state.user,
            applicationContext: state.applicationContext
        }
    };
};

export const FolioDetailsContainer = connect(mapStateToProps)(FolioDetailsContainerComponent);
